
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Contrat from '@/extend/classes/Contrat';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeContrat' })

export default class storeContrat extends VuexModule {
  // States
  private reccords: Contrat[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get contratLoading (): boolean {
    return this.dataLoading;
  }
  private get contratRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get contratLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewContrat() {
    return (): Contrat => { 
      return this.getContrat(0, true);
    }
  }

  
  public get getContrat () {
    return (id: number, canCreate = false): Contrat => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Contrat can't be 0")
        return new Contrat();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Contrat();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Contrat.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromContrat(data.reccords[0] as Contrat);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listContrat (): Contrat[] {
    return this.reccords;
  }

  public get listConfigContrat (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mContratRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mContratClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mContratLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mContratLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Contrat.fromJson(reccord as Contrat));
    })
    Contrat.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mContratConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mContratCreated (obj: Contrat): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareContrat(obj)) {
          api.fromContrat(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareContrat(obj)) {
            api.fromContrat(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mContratUpdated (obj: Contrat): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareContrat(obj)) {
          api.fromContrat(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mContratDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerContrat (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.contratRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerContrat(this.contratCreated, this.contratUpdated, this.contratDeleted);
          this.mContratRegistered();
        } else {
          setTimeout(() => resolve(this.registerContrat(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.contratLoading && !this.contratLoaded) {
          this.mContratLoading(true);
          return Contrat.list(filter)
            .then((data: ListData) => {
              this.mContratLoaded(data);
              this.mContratLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredContrat (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.contratLoading) {
        this.mContratLoading(true);
        return Contrat.list(filter)
          .then((data: ListData) => {
            this.mContratLoaded(data);
            this.mContratLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createContrat (obj: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      return Contrat.fromJson(obj).createForStoreContrat()
        .then((reccords) => {
          this.mContratCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateContrat (obj: Contrat): Promise<Contrat> {
    return new Promise((resolve, reject) => {
      return Contrat.fromJson(obj).updateForStoreContrat()
        .then((reccords) => {
          this.mContratUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteContrat (obj: Contrat): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Contrat.fromJson(obj).deleteForStoreContrat()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mContratDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private contratCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mContratConfigUpdated(config)
    const obj = objConfig.obj as Contrat;
    this.mContratCreated(Contrat.fromJson(obj));
  }

  @Action
  private contratUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mContratConfigUpdated(config)
    const obj = objConfig.obj as Contrat;
    this.mContratUpdated(Contrat.fromJson(obj));
  }

  @Action
  private contratDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Contrat;
    this.mContratDeleted(obj.id);
  }
}
